// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Rafael Pereira Satyro

import type { Icon } from 'iconsax-react';

const ChevronLeftRoundedIcon: Icon = ({ size = 24, color, variant: _variant, className, style, ...rest }) => {
  const stroke = color || '#2D0A6C';
  const fill = '#141414';
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-icon="chevron left rounded"
      className={className}
      style={style}
      {...rest}
    >
      <path d="M14.8242 3.90332C14.919 3.80868 15.0821 3.80861 15.1768 3.90332C15.2713 3.99805 15.2714 4.16116 15.1768 4.25586L8.65625 10.7764C7.98158 11.4515 7.98157 12.5475 8.65625 13.2227L15.1768 19.7432C15.2697 19.8362 15.2704 19.9945 15.1807 20.0898C15.1152 20.1479 15.048 20.1699 15 20.1699C14.9356 20.1699 14.8754 20.1469 14.8242 20.0957L8.30371 13.5762C7.43897 12.7114 7.43897 11.2876 8.30371 10.4229L14.8242 3.90332Z" fill={fill} stroke={stroke} />
    </svg>
  );
};

export { ChevronLeftRoundedIcon };
